import { render, staticRenderFns } from "./MySettings.vue?vue&type=template&id=098b9b8c&scoped=true&"
import script from "./MySettings.vue?vue&type=script&lang=ts&"
export * from "./MySettings.vue?vue&type=script&lang=ts&"
import style0 from "./MySettings.vue?vue&type=style&index=0&id=098b9b8c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "098b9b8c",
  null
  
)

export default component.exports